<template lang="pug">
.live-timetable-area
  .timetable-title {{ targetDate }}
  .timetable-main
    .timetable-main-content
      //- 上午時段
      TimeableItem.morning(
        v-if="use_morning",
        time="morning",
        :course_list="morningCourseList",
        @clickOptionOut="clickOption"
      )

      //- 下午時段
      TimeableItem.afternoon(
        v-if="use_afternoon",
        time="afternoon",
        :course_list="afternoonCourseList",
        @clickOptionOut="clickOption"
      )

      //- 晚上時段
      TimeableItem.night(
        v-if="use_night",
        time="night",
        :course_list="nightCourseList",
        @clickOptionOut="clickOption"
      )

      .clearfix
</template> 

<script>
import $ from 'jquery'
import TimeableItem from './live-timetable-item.vue'
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    coursetable_data: false,
  },
  data () {
    return {
      targetDate: '',
      // 上午課程列表
      morningCourseList: {},
      use_morning: false,
      // 下午課程列表
      afternoonCourseList: {},
      use_afternoon: false,
      // 晚上課程列表
      nightCourseList: {},
      use_night: false,
      // 處理需要操作的課程ID
      course_id: false,
      process_course: false,
    }
  },
  created () {
    this.$root.getSysSetting('mp_course')
    setTimeout(() => { this.fixORflow() }, 100);
    this.getCourseList('all', '', false)
  },
  components: {
    TimeableItem
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    use_morning (_status) {
      this.fixORflow()
    },
    // eslint-disable-next-line no-unused-vars
    use_afternoon (_status) {
      this.fixORflow()
    },
    // eslint-disable-next-line no-unused-vars
    use_night (_status) {
      this.fixORflow()
    },
  },
  methods: {
    //- timeable 數量更動
    fixORflow () {
      var table_num = 0
      if (this.use_morning) {
        if (this.use_afternoon && this.use_night) {
          table_num = 3
        }
        if (!this.use_afternoon && !this.use_night) {
          table_num = 1
        }
        if (!this.use_afternoon && this.use_night) {
          table_num = 2
        }
        if (this.use_afternoon && !this.use_night) {
          table_num = 2
        }
      }
      if (!this.use_morning) {
        if (this.use_afternoon && this.use_night) {
          table_num = 2
        }
        if (!this.use_afternoon && !this.use_night) {
          table_num = 0
        }
        if (!this.use_afternoon && this.use_night) {
          table_num = 1
        }
        if (this.use_afternoon && !this.use_night) {
          table_num = 1
        }
      }
      console.log('顯示的time數量 ==== ' + table_num)
      this.fixedOrflowTable(table_num)
    },
    //- 固定或解鎖
    fixedOrflowTable (_num) {
      if (_num === 1) {
        $('.live-timetable-view .timetable-main').css({ 'overflow': 'hidden' })
        $('.live-timetable-view .timetable-main-content').css({ 'width': '90vmin' })
      }
      if (_num === 2) {
        $('.live-timetable-view .timetable-main').css({ 'overflow': 'auto' })
        $('.live-timetable-view .timetable-main-content').css({ 'width': '180vmin' })
      }
      if (_num === 3) {
        $('.live-timetable-view .timetable-main').css({ 'overflow': 'auto' })
        $('.live-timetable-view .timetable-main-content').css({ 'width': '270vmin' })
      }
    },
    // 重新拉取課程列表
    async getCourseList () {
      console.log('--> 預備請求獲取直播再現課程資料...')
      // 開啟載入中
      this.$root.useLoading()
      // 獲得課程清單
      await this.$root.apis.getLiveCourseList(this.processCousreListSuccess, this.processCousreListError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 拉回課程列表成功
    processCousreListSuccess (_response) {
      if (_response.body.error_code !== 0) {
        return this.processCousreListError(_response)
      }

      // 處理課程清單
      let courseList = _response.body.data
      let targetDate = _response.body.show_date
      console.log('--> 獲得的課程資料: ', courseList)

      // 分類課表
      let vm = this
      let morningCourseList = {}
      let afternoonCourseList = {}
      let nightCourseList = {}
      this.use_morning = false
      this.use_afternoon = false
      vm.use_night = false
      courseList.forEach(function (_courseItem) {

        // 課程展開開關
        _courseItem.click_status = false

        // 上午時段課程清單
        if (_courseItem.start_hour <= 12) {
          vm.use_morning = true
          if (morningCourseList[_courseItem.start_time]) {
            morningCourseList[_courseItem.start_time].push(_courseItem)
          } else {
            morningCourseList[_courseItem.start_time] = []
            morningCourseList[_courseItem.start_time].push(_courseItem)
          }
        }

        // 下午時段課程清單
        else if (_courseItem.start_hour <= 17) {
          vm.use_afternoon = true
          if (afternoonCourseList[_courseItem.start_time]) {
            afternoonCourseList[_courseItem.start_time].push(_courseItem)
          } else {
            afternoonCourseList[_courseItem.start_time] = []
            afternoonCourseList[_courseItem.start_time].push(_courseItem)
          }
        }

        // 晚上時段課程清單
        else {
          vm.use_night = true
          if (nightCourseList[_courseItem.start_time]) {
            nightCourseList[_courseItem.start_time].push(_courseItem)
          } else {
            nightCourseList[_courseItem.start_time] = []
            nightCourseList[_courseItem.start_time].push(_courseItem)
          }
        }
      })

      // 更新資料
      this.targetDate = targetDate
      this.morningCourseList = morningCourseList
      this.afternoonCourseList = afternoonCourseList
      this.nightCourseList = nightCourseList

      console.log('--> 課程資料獲取完成...');
    },
    // 拉回課程列表失敗
    processCousreListError () {

    },
    // showhideCourse (_time, _start_time, _index_in) {
    //   console.log(_start_time)
    //   console.log(_index_in)
    //   if (_time === 'morning') {
    //     this.morningCourseList[_start_time][_index_in].click_status = !this.morningCourseList[_start_time][_index_in].click_status
    //   }
    //   if (_time === 'afternoon') {
    //     this.afternoonCourseList[_start_time][_index_in].click_status = !this.afternoonCourseList[_start_time][_index_in].click_status
    //   }
    //   if (_time === 'night') {
    //     this.nightCourseList[_start_time][_index_in].click_status = !this.nightCourseList[_start_time][_index_in].click_status
    //   }

    //   setTimeout(() => { this.$forceUpdate() }, 100);
    // },
    // 選取課程資料
    clickCourse (_courseID) {
      console.log('--> 用戶點選課程...');
      this.$root.enterCourse(_courseID)
    },
    // 當用戶點擊課程按鈕
    clickOption (_course, _type) {
      console.log(_course)
      // 紀錄目前操作的課程ID
      _course.type = 'reappear'
      this.course_id = _course.course_id
      this.process_course = _course

      // 請求觀看直播
      if (_type === 'live') {
        // 是否已經購買過課程
        if (_course.order_live) {
          this.openCourseLive()
          return
        }

        // 處理登記直播
        this.$root.openOptionView({
          title: "直播課程",
          text_1: "您選擇直播課程",
          text_2: '需要扣除 ' + this.$root.common.formatNumber(_course.course_point, 0) + ' 點數，確認進入直播？',
          course_text: _course.title,
          option_1: "確認",
          option_2: "我再考慮",
          option_1_fun: this.openCourseLive,
          option_2_fun: false
        })
        return
      }

      // 發生未知的問題
      else {
        this.$root.openOptionView({
          title: "發生未知的問題",
          text_1: "很抱歉，目前功能發生障礙",
          text_2: '請稍後再試',
          course_text: '',
          option_1: "瞭解",
          option_2: "",
          option_1_fun: false,
          option_2_fun: false
        })
        return
      }
    },
    // 請求預約團體班課程
    async registerCourse () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求預約課程
      await this.$root.apis.registerGroupCourse(this.course_id, this.processRegCourseSuccess, this.processRegCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回預約成功的資料
    processRegCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegCourseError(_response)
      }

      // 更新課程資料
      this.getCourseList('all', '', false)

      // 進入會議室
      if (this.process_course.is_started) {
        this.$root.openMeeting(this.course_id)
      }

      // 告知學員已經預約成功
      else {
        this.$root.openOptionView({
          title: "預約成功",
          text_1: '課程已經預約成功',
          text_2: '請在課程開始時進入會議室哦！',
          course_text: '',
          option_1: "瞭解",
          option_2: '',
          option_1_fun: false,
          option_2_fun: false
        })
      }
    },
    // 處理返回預約失敗的資料
    processRegCourseError (_error) {
      this.$root.openOptionView({
        title: "預約失敗",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    },
    // 請求進入課程直播
    async openCourseLive () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求進入課程直播
      await this.$root.apis.liveReappearCourse(this.course_id, this.processLiveCourseSuccess, this.processLiveCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回直播請求成功的資料
    processLiveCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegCourseError(_response)
      }

      // 進入會議室
      this.$root.openLiveReappear(this.course_id)
    },
    // 處理返回直播請求失敗的資料
    processLiveCourseError (_error) {
      this.$root.openOptionView({
        title: "發生問題",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    }
  }
}
</script>
<style lang="sass" scoped>
</style>
